import {SettingParam} from "@/types/node";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import {useState} from "react";
import {useEffect} from "react";
import {cn} from "@/lib/utils";

export const SettingSelect = ({
  param,
  handleChange,
  selectOptions = [],
  placeholder,
  disabled = false,
  selectedNodeId,
  ...props
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: string) => void;
  selectOptions: {name: string; value: string; icon?: string}[];
  placeholder?: string;
  disabled: boolean;
  selectedNodeId: string;
  props?: any;
}) => {
  const [value, setValue] = useState(param.value?.toString() || "");

  useEffect(() => {
    if (param.value !== value) {
      setValue(param.value?.toString() || "");
    }
  }, [param, selectedNodeId]);

  return (
    <div className="mb-4">
      {param.label && (
        <label className="text-sm font-medium text-label mb-2 flex items-center justify-between">
          {param.label}
        </label>
      )}
      <Select
        onValueChange={value => handleChange(param, value)}
        value={value.toString()}
        disabled={disabled}
        {...props}
      >
        <SelectTrigger
          className={cn(disabled ? "pointer-events-none" : "", param.className)}
        >
          <SelectValue placeholder={placeholder || "Select"} />
        </SelectTrigger>
        <SelectContent>
          {selectOptions.length > 0 &&
            selectOptions.map(option => (
              <SelectItem
                value={option.value}
                key={option.value}
                icon={option.icon}
              >
                {option.name}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  );
};
